import { Auth0ApplicationID, Auth0FrontendUser, Auth0OrganizationData, Auth0OrganizationID, Auth0OrganizationName, IHttpResponse } from '@gr/shared/models';
import { addParam, getRedirectUrlByOrg, isPreProdOrg } from '@gr/shared/utils';
import { useLocation } from 'react-router-dom';
import { axiosGet } from '../authAxios';

export interface Auth0FrontendConfig {
  label: string;
  clientId: Auth0ApplicationID;
  organization: Auth0OrganizationName,
  organizationId: Auth0OrganizationID;
  apiUrl: string;
  websocketUrl: string;
  gsdUrl: string;
}

export function getUrlParam(name: string) {
  const params = new URLSearchParams(useLocation().search);
  return params.has(name) ? (params.get(name) ?? undefined) : undefined;
}

export function getSubDomain() {
  return window?.location?.host?.split('.')?.[0];
}

export interface GotToOrgRequest {
  orgId: Auth0OrganizationID | undefined;
  orgName: Auth0OrganizationName | undefined;
  invitation?: string | undefined;
}

export function goToOrg({ orgId, orgName, invitation }: GotToOrgRequest) {
  const url = getRedirectUrlByOrg({ baseUrl: window?.location?.origin, orgId, orgName });
  window.location.replace(!!invitation ? addParam(url, `invitation=${invitation}`) : url);
}

export async function getUserOrganizations(auth0User: Auth0FrontendUser) {
  const hasAllP2PTenants = auth0User?.app_metadata?.hasAllP2PTenants ?? false;

  const organizations: Auth0OrganizationData[] = hasAllP2PTenants
    ? await getAllOrganizations()
    : auth0User?.organizations ?? [];

  const isLocal = window.location.origin.includes('localhost');

  return isLocal
    ? organizations?.filter(org => isPreProdOrg(org)) ?? []
    : organizations ?? [];
}

async function getAllOrganizations() {
  const result = await axiosGet<IHttpResponse<Auth0OrganizationData[]>>('/auth0-organizations');
  return result?.data?.data ?? [];
}
